import { render } from "./Error404Module.vue?vue&type=template&id=d116d490"
import script from "./Error404Module.vue?vue&type=script&lang=js"
export * from "./Error404Module.vue?vue&type=script&lang=js"

import exportComponent from "/builds/septacodeprojects/septacode.com/frontend/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__